// src/components/Organisations.js
import React, { useEffect, useState } from "react";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { db } from "../services/firebase";

export default function Organisations() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [tombolas, setTombolas] = useState([]);
  const [loadingTombolas, setLoadingTombolas] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => { charger(); }, []);

  async function charger() {
    const snap = await getDocs(collection(db, "organisations"));
    const list = await Promise.all(snap.docs.map(async (d) => {
      const org = { id: d.id, ...d.data() };
      const tombolasSnap = await getDocs(collection(db, "organisations", d.id, "tombolas"));
      org.tombolaCount = tombolasSnap.size;
      org.proCount = tombolasSnap.docs.filter((t) => t.data().plan === "pro").length;
      // Stocker les noms de tombolas pour la recherche
      org.tombolaNames = tombolasSnap.docs.map((t) => t.data().nom || "").join(" ").toLowerCase();
      // Stocker les emails des membres
      const membresSnap = await getDocs(collection(db, "organisations", d.id, "membres"));
      org.membresEmails = membresSnap.docs.map((m) => m.id).join(" ").toLowerCase();
      return org;
    }));
    setOrgs(list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0)));
    setLoading(false);
  }

  async function voirTombolas(org) {
    setSelected(org);
    setLoadingTombolas(true);
    const snap = await getDocs(collection(db, "organisations", org.id, "tombolas"));
    setTombolas(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    setLoadingTombolas(false);
  }

  async function passerEnPro(orgId, tombolaId, tombolaNom) {
    if (!window.confirm(`Passer "${tombolaNom}" en Pro gratuitement ?`)) return;
    await updateDoc(doc(db, "organisations", orgId, "tombolas", tombolaId), {
      plan: "pro",
      paidAt: new Date(),
      stripeSessionId: "manual_admin",
    });
    setTombolas((prev) => prev.map((t) => t.id === tombolaId ? { ...t, plan: "pro" } : t));
    setMsg(`✅ "${tombolaNom}" passée en Pro !`);
    setTimeout(() => setMsg(""), 3000);
  }

  const s_lower = search.toLowerCase();
  const filtered = orgs.filter((o) =>
    o.nom?.toLowerCase().includes(s_lower) ||
    o.adminEmail?.toLowerCase().includes(s_lower) ||
    o.tombolaNames?.includes(s_lower) ||
    o.membresEmails?.includes(s_lower)
  );

  if (loading) return <div style={s.loading}>⏳ Chargement…</div>;

  return (
    <div style={{ display: "flex", gap: "1.5rem" }}>
      {/* Liste des orgs */}
      <div style={{ flex: 1 }}>
        <input type="text" placeholder="🔍 Rechercher par nom, email, tombola ou bénévole…"
          value={search} onChange={(e) => setSearch(e.target.value)}
          style={s.search} />

        <div style={s.count}>{filtered.length} organisation{filtered.length > 1 ? "s" : ""}</div>

        <div style={s.list}>
          {filtered.map((org) => (
            <div key={org.id} style={{ ...s.orgCard, ...(selected?.id === org.id ? s.orgCardActive : {}) }}
              onClick={() => voirTombolas(org)}>
              <div style={s.orgAvatar}>{org.nom?.charAt(0).toUpperCase()}</div>
              <div style={s.orgInfo}>
                <div style={s.orgNom}>{org.nom}</div>
                <div style={s.orgEmail}>{org.adminEmail}</div>
                <div style={s.orgMeta}>
                  {org.tombolaCount} tombola{org.tombolaCount > 1 ? "s" : ""}
                  {org.proCount > 0 && <span style={s.badgePro}>{org.proCount} Pro</span>}
                </div>
              </div>
              <div style={s.orgChevron}>›</div>
            </div>
          ))}
        </div>
      </div>

      {/* Détail org */}
      {selected && (
        <div style={s.detail}>
          <h3 style={s.detailTitle}>{selected.nom}</h3>
          <p style={s.detailEmail}>👤 {selected.adminEmail}</p>
          <p style={s.detailDate}>
            📅 Créée le {selected.createdAt?.toDate?.().toLocaleDateString("fr-FR") || "—"}
          </p>

          {msg && <div style={s.msg}>{msg}</div>}

          <h4 style={s.tombolaTitle}>Tombolas</h4>
          {loadingTombolas ? (
            <div style={s.loading}>⏳</div>
          ) : tombolas.length === 0 ? (
            <p style={s.empty}>Aucune tombola.</p>
          ) : (
            <div style={s.tombolaList}>
              {tombolas.map((t) => (
                <div key={t.id} style={s.tombolaRow}>
                  <div>
                    <div style={s.tombolaNom}>{t.nom}</div>
                    <div style={s.tombolaAnnee}>{t.annee}</div>
                  </div>
                  {t.plan === "pro" ? (
                    <span style={s.badgeProBig}>⭐ Pro</span>
                  ) : (
                    <button onClick={() => passerEnPro(selected.id, t.id, t.nom)} style={s.btnPro}>
                      Passer en Pro
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  loading: { textAlign:"center", padding:"2rem", color:"#667eea" },
  search: { width:"100%", padding:"0.75rem 1rem", border:"1.5px solid #e0e0e0", borderRadius:"10px", fontSize:"0.95rem", outline:"none", marginBottom:"0.75rem", boxSizing:"border-box" },
  count: { fontSize:"0.82rem", color:"#aaa", marginBottom:"0.75rem" },
  list: { display:"flex", flexDirection:"column", gap:"8px" },
  orgCard: { display:"flex", alignItems:"center", gap:"12px", background:"#fff", borderRadius:"12px", padding:"1rem", cursor:"pointer", border:"1.5px solid #eee", transition:"all 0.15s" },
  orgCardActive: { border:"1.5px solid #667eea", background:"#eef0ff" },
  orgAvatar: { width:"44px", height:"44px", borderRadius:"50%", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:"800", fontSize:"1.1rem", flexShrink:0 },
  orgInfo: { flex:1 },
  orgNom: { fontWeight:"700", color:"#1a1a2e", fontSize:"0.95rem" },
  orgEmail: { fontSize:"0.78rem", color:"#aaa", marginTop:"2px" },
  orgMeta: { display:"flex", alignItems:"center", gap:"8px", fontSize:"0.78rem", color:"#888", marginTop:"4px" },
  badgePro: { background:"#fff8e1", color:"#ff8f00", borderRadius:"10px", padding:"1px 8px", fontWeight:"700", fontSize:"0.72rem" },
  orgChevron: { color:"#aaa", fontSize:"1.25rem" },
  detail: { width:"320px", background:"#fff", borderRadius:"12px", padding:"1.5rem", border:"1px solid #eee", alignSelf:"flex-start", position:"sticky", top:"1rem" },
  detailTitle: { fontSize:"1.1rem", fontWeight:"800", color:"#1a1a2e", marginBottom:"0.5rem" },
  detailEmail: { fontSize:"0.85rem", color:"#555", marginBottom:"4px" },
  detailDate: { fontSize:"0.85rem", color:"#888", marginBottom:"1rem" },
  msg: { background:"#e8f5e9", color:"#2e7d32", borderRadius:"8px", padding:"0.75rem", fontSize:"0.85rem", marginBottom:"1rem" },
  tombolaTitle: { fontSize:"0.9rem", fontWeight:"700", color:"#333", marginBottom:"0.75rem" },
  empty: { color:"#aaa", fontSize:"0.85rem" },
  tombolaList: { display:"flex", flexDirection:"column", gap:"8px" },
  tombolaRow: { display:"flex", alignItems:"center", justifyContent:"space-between", background:"#f7f8fc", borderRadius:"8px", padding:"0.75rem" },
  tombolaNom: { fontWeight:"600", color:"#1a1a2e", fontSize:"0.88rem" },
  tombolaAnnee: { fontSize:"0.75rem", color:"#aaa" },
  badgeProBig: { background:"#fff8e1", color:"#ff8f00", borderRadius:"8px", padding:"4px 10px", fontWeight:"700", fontSize:"0.8rem" },
  btnPro: { padding:"5px 12px", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"8px", cursor:"pointer", fontSize:"0.78rem", fontWeight:"700" },
};
